var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailabilityBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8331 2.5H4.16706C3.24211 2.5 2.50049 3.25 2.50049 4.16667V15.8333C2.50049 16.75 3.24211 17.5 4.16706 17.5H15.8331C16.7497 17.5 17.4997 16.75 17.4997 15.8333V4.16667C17.4997 3.25 16.7497 2.5 15.8331 2.5ZM14.1665 10.8333H10.8334V14.1667H9.16678V10.8333H5.83364V9.16667H9.16678V5.83333H10.8334V9.16667H14.1665V10.8333Z",
    fill: "#25282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityBlack);
export default __webpack_public_path__ + "static/media/availability_black.334a0701b2e4a47c110dd45cc4727e35.svg";
export { ForwardRef as ReactComponent };